import { createReducer } from "@reduxjs/toolkit";
import React, { createContext, useContext, useReducer } from "react";
import { STATUS } from "../constants/status.constant";

const HardPromotionContext = createContext();

const INIT_STATE = {
  filter: {
    limit: 10,
    page: 1,
    status: STATUS.ACTIVE,
    type: "",
  },
  form: {
    id: null,
    loading: false,
    data: {
      id: null,
      code: null,
      start_date: null,
      end_date: null,
      status: "active",
      items: [],
      free: [],
    },
  },
};

const reducer = createReducer(INIT_STATE, (builder) => {
  builder
    .addCase("SET_FILTER", (state, { payload }) => {
      state.filter = { ...state.filter, ...payload };
    })
    .addCase("LOAD_DATA", (state) => {
      state.form.loading = true;
    })
    .addCase("LOAD_DATA_SUCCESS", (state, { payload }) => {
      state.form = {
        ...state.form,
        id: payload.id,
        data: {
          ...payload,
        },
      };
    })
    .addCase("LOAD_DATA_FAIL", (state) => {
      state.form = {
        ...INIT_STATE.form,
      };
    })
    .addDefaultCase(() => {});
});

export const useHardPromotionMutate = () => {
  const context = useContext(HardPromotionContext);
  if (!context)
    throw new Error(
      "Hard Promotion Mutate Context must be used within Hard Promotion Mutate Provider"
    );
  return context;
};

export const HardPromotionMutateProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);
  return (
    <HardPromotionContext.Provider value={{ state, dispatch }}>
      {children}
    </HardPromotionContext.Provider>
  );
};
